export const unauthorizedError = (error, history) => dispatch => {
  dispatch({ type: "OPEN_ERROR", payload: error });
  history.goBack();
};


// WEBPACK FOOTER //
// ./src/actions/ErrorActions.js